export const LOGIN_USER = 'LOGIN_USER'
